export const en = {
  common: {
    play: 'Play',
    next: 'Next',
    back: 'Back',
    submit: 'Submit',
    score: 'Score',
    language: 'Language',
    loading: 'Loading...',
    error: 'Error',
    anonymous: 'Anonymous',
    leaderboard: 'Leaderboard',
  },
  home: {
    welcome: 'Welcome to EcoQuiz!',
    startGame: 'Start Game',
    description: 'Test your knowledge about ecology and environment',
  },
  game: {
    question: 'Question',
    timeLeft: 'Time Left',
    correctAnswer: 'Correct Answer!',
    wrongAnswer: 'Wrong Answer',
    seconds: 'seconds',
    hint: 'Hint',
    lifelines: 'Lifelines',
    totalTime: 'Total Time',
    difficulty: 'Difficulty',
    tip: 'Tip',
    failedToFetch: 'Failed to fetch question',
    failedToSubmit: 'Failed to submit answer',
    failedToUseTip: 'Failed to use tip',
    failedToUse5050: 'Failed to use 50/50',
    noMoreQuestions: 'No more questions available',
  },
  gameEnd: {
    congratulations: 'Congratulations!',
    finalScore: 'Your Final Score',
    playAgain: 'Play Again',
    backToHome: 'Back to Home',
    greatJob: 'Great Job,',
    ecoWarrior: 'Eco Warrior',
    points: 'points',
    time: 'Time',
    yourName: 'Your Name (optional)',
    saveScore: 'Save Score',
    failedToSave: 'Failed to save score',
  },
  leaderboard: {
    ecoChampions: 'Eco Champions',
    rank: 'Rank',
    player: 'Player',
    score: 'Score',
    questions: 'Questions',
    time: 'Time',
    noEntries: 'No entries yet',
    failedToFetch: 'Failed to fetch leaderboard',
  },
  footer: {
    supportedBy: 'Proudly Supported By',
  },
  difficulty: {
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
    very_hard: "Very Hard",
  }
} 